import { FC, Fragment } from 'react';

import Subtitle from './Subtitle';
import Title from './Title';

const Header: FC = () => {
  return (
    <Fragment>
      <Title>¡Estos terrenos son similares!</Title>

      <Subtitle>
        ¿Quieres contactarlos? Aumentarás tus opciones en menos tiempo.
      </Subtitle>
    </Fragment>
  );
};

export default Header;
